import { memo } from 'react';

import { Outrights } from './Outrights';

export * from './Outrights';

export default memo(Outrights);
